import { render } from "./tutorial.vue?vue&type=template&id=4bfc9130&scoped=true"
import script from "./tutorial.vue?vue&type=script&lang=js"
export * from "./tutorial.vue?vue&type=script&lang=js"

import "./tutorial.vue?vue&type=style&index=0&id=4bfc9130&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bfc9130"]])

export default __exports__